export type AccountHealthMetricBand = 'green' | 'yellow' | 'red' | 'neutral';

export interface AccountHealthMetricWarning {
    type: 'low-order-place-rate' | 'low-containment-rate';
    label: string;
    message: string;
    level: 'p1';
}

export const LOW_ORDER_PLACE_RATE_MESSAGE = 'Order Place Rate is below 70% for the selected month. Review order completion failures and POS configuration.';
export const LOW_CONTAINMENT_RATE_MESSAGE = 'Containment Rate is below 60% for the selected month. Review unsuccessful actions, transfers, and assistant configuration.';

export const getOrderPlaceRateBand = (rate: number | null): AccountHealthMetricBand => {
    if (rate === null || !Number.isFinite(rate)) return 'neutral';
    if (rate > 85) return 'green';
    if (rate >= 70) return 'yellow';
    return 'red';
};

export const getContainmentRateBand = (rate: number | null): AccountHealthMetricBand => {
    if (rate === null || !Number.isFinite(rate)) return 'neutral';
    if (rate > 80) return 'green';
    if (rate >= 60) return 'yellow';
    return 'red';
};

export const getAccountHealthMetricWarnings = (
    orderRate: number | null,
    containmentRate: number | null,
    includesOrdering: boolean,
    includesHealthcare: boolean,
    loadFailed: boolean
): AccountHealthMetricWarning[] => {
    if (loadFailed) return [];

    const warnings: AccountHealthMetricWarning[] = [];
    if (includesOrdering && getOrderPlaceRateBand(orderRate) === 'red') {
        warnings.push({
            type: 'low-order-place-rate',
            label: 'Low Order Place Rate',
            message: LOW_ORDER_PLACE_RATE_MESSAGE,
            level: 'p1'
        });
    }
    if (includesHealthcare && getContainmentRateBand(containmentRate) === 'red') {
        warnings.push({
            type: 'low-containment-rate',
            label: 'Low Containment Rate',
            message: LOW_CONTAINMENT_RATE_MESSAGE,
            level: 'p1'
        });
    }
    return warnings;
};
